var render, staticRenderFns
import script from "./DisabledWrapper.vue?vue&type=script&lang=ts&"
export * from "./DisabledWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./DisabledWrapper.vue?vue&type=style&index=0&id=384f727c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports